import moment from "moment";
// escapes the escape character
const escape = (str) => {
  let newStr = str.replace(/(\\)/gim, "\\\\");
  return newStr;
};
// To retain the new line
const newLine = (str) => {
  let newStr = str.replace(/\n/gi, "\\n");
  return newStr;
};

// make sure to delete null fields when looping through arrays

const parseObjectForGraphql = (obj) => {
  let graphqlstr = "";
  // Parsing Array of Object for GQL
  Object.keys(obj).forEach((x) => {
    if (Array.isArray(obj[x])) {
      let arrayString = x + ":[";
      obj[x].map((xy) => {
        if (typeof xy === "object") {
          arrayString += "{";
          for (var property in xy) {
            arrayString +=
              property + ': "' + newLine(escape(xy[property])) + '",';
          }
          arrayString += "},";
        } else if (typeof xy === "string") {
          arrayString += `"${xy}",`;
        }
      });
      graphqlstr += `${arrayString}]`;
    }
    // Parsing Object with numbers as values for GQL (i.e Counties)
    else if (
      typeof obj[x] === "object" &&
      obj[x] instanceof Date == false &&
      obj[x] !== null
    ) {
      let arrayString2 = x + ":";
      arrayString2 += "{";
      for (var property in obj[x]) {
        if (isNaN(obj[x][property])) {
          arrayString2 +=
            property + ': "' + newLine(escape(obj[x][property])) + '",';
        } else {
          arrayString2 += property + ": " + obj[x][property] + ",";
        }
      }
      arrayString2 += "},";
      graphqlstr += `${arrayString2}`;
    } else if (moment(obj[x]).isValid() && obj[x] instanceof Date) {
      const date = moment(obj[x]).format("MM/DD/YYYY");
      graphqlstr += `${x}: "${newLine(escape(date))}",`;
    } else if (obj[x] !== null) {
      graphqlstr += `${x}: "${newLine(escape(obj[x]))}",`;
    }
  });
  return graphqlstr;
};

const parseMultiSelectCheckboxForGQL = (formData, values) => {
  let multiSelectArr = [];
  if (
    formData?.[
      "new_profile_worker_housing_applicable_housing_standards_local"
    ]?.[0] === "YES"
  ) {
    // Set it to type String first, then push into an array of values.
    formData["new_profile_worker_housing_applicable_housing_standards_local"] =
      "YES";
    // Push to the machine name which holds the array of values
    multiSelectArr.push({
      value: "applicable_housing_standards_local",
      label: "local",
    });
  }
  if (
    formData?.[
      "new_profile_worker_housing_applicable_housing_standards_swa"
    ]?.[0] === "YES"
  ) {
    formData["new_profile_worker_housing_applicable_housing_standards_swa"] =
      "YES";
    multiSelectArr.push({
      value: "applicable_housing_standards_swa",
      label: "swa",
    });
  }
  if (
    formData?.[
      "new_profile_worker_housing_applicable_housing_standards_other_state"
    ]?.[0] === "YES"
  ) {
    formData[
      "new_profile_worker_housing_applicable_housing_standards_other_state"
    ] = "YES";
    multiSelectArr.push({
      value: "applicable_housing_standards_other_state",
      label: "other state",
    });
  }
  if (
    formData["new_profile_worker_housing_applicable_housing_standards_other"] &&
    formData[
      "new_profile_worker_housing_applicable_housing_standards_other"
    ][0] === "YES"
  ) {
    formData["new_profile_worker_housing_applicable_housing_standards_other"] =
      "YES";
    multiSelectArr.push({
      value: "applicable_housing_standards_other",
      label: "other",
    });
  }
  if (
    formData?.[
      "new_profile_worker_housing_applicable_housing_standards_federal"
    ]?.[0] === "YES"
  ) {
    formData[
      "new_profile_worker_housing_applicable_housing_standards_federal"
    ] = "YES";
    multiSelectArr.push({
      value: "applicable_housing_standards_federal",
      label: "federal",
    });
  }
  formData.new_profile_worker_housing_applicable_housing_standards = [
    ...multiSelectArr,
  ];

  return formData;
};

//fill array with values
//loop  around

export { parseObjectForGraphql, parseMultiSelectCheckboxForGQL };
